import { Button, IconButton, makeStyles } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { datesAreOnSameDay, prettyDate, simpleDate, to_YYYYMMDDHHMMSS } from '../../../config/dateFormatting';
import { planEatApi } from '../../../planEatApi/PlanEatApi';
import { IBookingContent, IDefaultDishContent, IDefaultSeatingContent, IDishContent, IOfficeContent, IPriceModelContent, ISeatingContent, IVersionedObject } from '../../../planEatApi/PlanEatFacade';
import { FrontendApi } from '../../../planEatApi/FrontendApi';
import { SeatingCreationModal } from '../../../components/modals/SeatingCreationModal';
import { CustomCheckBox } from '../../../components/ui/CustomCheckBox';
import { DefaultSeatingModal } from '../../../components/modals/DefaultSeatingModal';
import { OfficeContext } from '../../../config/Context';
import { WeekPicker } from '../../../components/ui/WeekPicker';
import { v4 as uuidv4 } from 'uuid';
import { DefaultMenuItemModal } from '../../../components/modals/DefaultMenuItemModal';
import { GenerateModal } from '../../../components/modals/GenerateModal';
import { SeatingDeletionModal } from '../../../components/modals/SeatingDeletionModal';
import toast from 'react-hot-toast';
import { weekDays } from '../../../constants/weekDays';
import { clone } from '../../../utils/clone';
import { resetDefaultMenuItem, resetDefaultSeating, resetDish, resetSeating } from '../../../utils/resetObjects';
import { errorToast, successToast } from '../../../utils/crudToast';
import { MdAccessTime, MdAddCircleOutline, MdClose, MdModeEditOutline, MdPeopleAlt } from 'react-icons/md';
import { DATE_QUERY_PARAM, DISH_CO2_IMPACT_DEFAULT, NEW_ITEM_ID } from '../../../constants/constants';
import { isSeatingVerified } from '../../../utils/verifyObjects';
import { useQuery } from '../../../hooks/useQuery';
import { useHistory } from 'react-router-dom';
import { extractErrorMessage } from '../../../components/utils/ErrorHandler';


const useStyles = makeStyles((theme: any) => ({
    dishNumberContainer:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        minHeight: 20,
        minWidth:20,
        maxWidth: 20,
        maxHeight: 20,
        
        borderRadius: '50%',
        border:'1px #999999 solid',
        color:'#999999',
        marginRight: 10,
    },
    dragAndDropRow:{
        display:'grid',
        justifyContent: 'space-between',
        alignItems:'start',
        gridTemplateColumns:'repeat(5, minmax(0, 1fr))',
        columnGap: 10
    },
    dragAndDropDayContainer:{
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        minHeight: 250,
        padding: 10,
    },
    dateTitle:{
       color:'#374251',
       fontSize: '80%',
       fontWeight: 700,
    },
    dragAndDropDishContainer:{
        fontSize: '60%',
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
        flexDirection:'row',
        borderBottom: '1px dashed rgba(11, 37, 89, 0.2);',
        "&:last-child": {
            paddingBottom: 0
        },
    },
    addMenuItemContainer:{
        cursor:'pointer',
        display:'flex',
        justifyContent:'start',
        alignItems:'center',
        marginTop: 10,
        marginBottom: 10,
        borderRadius: 8,
        "& > *": {
            marginRight: 5
        },
    },
    addMenuItemText:{
        color: theme.palette.primary.main,
        fontSize: '70%',
        fontWeight: 700
    },
    addMenuIconStyle:{
        color: theme.palette.primary.main,
        height: 23
    },
    editIconContent:{
        maxHeight: '0.7em !important',
        maxWidth: '0.7em !important',  
    },
    editIconContainer:{
        padding: 4
    },
    seatingInfoContainer:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
    },
    seatingInfoContent:{
        display:'flex',
        justifyContent:'center',
        alignItems:'start',
        flexDirection:'column'
    },
    seatingInfoIconContainer: {
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        "& > *": {
            marginRight: 5
        },
    },
    seatingInfoIcon:{
        height: '12px !important',
        width: '12px !important',  
    },
    sectionTitle:{
        fontSize: 22,
        fontWeight: 700,
        color:'#374251',
    },
    sectionSubTitle:{
        fontSize: 12,
        fontWeight: 400,
        color:'#374251',
    },
    defaultSeatingContainer:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        flexDirection:'column',
        marginTop: 40
    },
    defaultSeatingContent:{
        display:'grid',
        gridTemplateColumns:'70% 28%',
        columnGap: '2%',
        justifyContent:'space-between'
    },
    highlightedAdminContainer:{
        width: '100%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        marginTop: 30,
        padding: 30
    },
    weekDayContainer:{
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
        cursor:'pointer',
        borderBottom: '1px dashed rgba(11, 37, 89, 0.2);',
        paddingBottom: 10,
        paddingTop: 10
    },
    defaultSeatingOptionsContainer:{
        marginTop: 20
    },
    defaultSeatingOptionsHeaders:{
        display:'grid',
        gridTemplateColumns:'20% 12% 28% 20% 20%',
        justifyContent:'start',
        alignItems:'center',
        "& > *": {
            fontSize: '100%',
            fontWeight: 700,
            color:'#374251',
        }
    },
    defaultSeatingOptionsContent:{
        display:'grid',
        gridTemplateColumns:'20% 12% 28% 20% 20%',
        justifyContent:'start',
        alignItems:'center',
        paddingTop: 10,
        paddingBottom: 10,
        borderBottom: '1px dashed rgba(11, 37, 89, 0.2);',
    },
    defaultMenuItemRowHeaders:{
        display:'grid',
        gridTemplateColumns:'15% 30% 20% 30%',
        justifyContent:'space-between',
        alignItems:'center',
        "& > *": {
            fontSize: '100%',
            fontWeight: 700,
            color:'#374251',
        }
    },
    defaultMenuItemRowContent:{
        display:'grid',
        gridTemplateColumns:'15% 30% 20% 30%',
        justifyContent:'space-between',
        maxWidth: "100%",
        alignItems:'center',
        paddingTop: 10,
        paddingBottom: 10,
        overflowWrap: "anywhere",
        borderBottom: '1px dashed rgba(11, 37, 89, 0.2);',
    },
    defaultSeatingNumberContent:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        minHeight: 25,
        minWidth:25,
        maxWidth: 25,
        maxHeight: 25,
        
        borderRadius: '50%',
        border:'1px '+theme.palette.primary.main+' solid',
        color:theme.palette.primary.main,
        marginRight: 10,
    },
    defaultSeatingNumberContainer:{
        display:'flex',
        justifyContent:'start',
        alignItems:'center',
    },
    applySeatingContainer:{
        display:'grid',
        justifyContent:'space-between',
        alignItems:'flex-end',
        gridTemplateColumns: '60% 15%',
        marginTop: 20
    },
    flexRowSpaceBetween:{
        display:'flex',    
        justifyContent:'space-between',
        alignItems:'center',
    },
    flexRowCenter:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
    },
    defaultMenuItemsContainer:{
        width: '100%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 6,
        marginTop: 30,
        padding: 30
    },
    generateSeatingsButton:{
        width:"100%",
        height: 80,
        marginTop: 15,
        borderRadius: 8,
        fontSize: 18
    }
}));

export const AdminOptionsTimes: React.FC = () => {
    // Styling
    const classes = useStyles();

    // Routing
    let queryParams = useQuery()
    let history = useHistory()

    // State
    const [date, setDate] = useState(new Date());
    const [weekDates, setWeekDates] = useState<Date[]>([]);
    const [dateFrom, setDateFrom] = useState(new Date());
    const [dateTo, setDateTo] = useState(new Date());
    const [minDate, setMinDate] = useState(new Date());
    const [availableDates, setAvailableDates] = useState<Date[]>([]);
    const [selectedDates, setSelectedDates] = useState<Date[]>([]);

    const [weekSeatings, setWeekSetatings] = useState<IVersionedObject<ISeatingContent>[][]>([]);
    const [weekDayIndex, setWeekDayIndex] = useState(0);
    
    const [hidden, setHidden] = useState(true);
    const [defaultSeatingHiddden, setDefaultSeatingHidden] = useState(true);
    const [generateSeatingsModalHidden,setGenerateSeatingsModalHidden] = useState(true)
    const [seatingDeletionModalHidden,setSeatingDeletionModalHidden] = useState(true)
    const [defaultMenuItemModalHidden, setDefaultMenuItemModalHidden] = useState(true)

    const [defaultSeatingsView,setDefaultSeatingsView] = useState<any[][]>([]);
    const [defaultMenuItemsView,setDefaultMenuItemsView] = useState<any[]>([]);
    const [weekDaysView,setWeekDaysView] = useState<any[]>([]);
    const [weekSeatingsView,setWeekSeatingsView] = useState<any[][]>([]);

    const [defaultSeating,setDefaultSeating] = useState<IDefaultSeatingContent>({
        defaultSeatingId: '',
        defaultSeatingName : '',
        defaultSeatingStartTime: '',
        defaultSeatingEndTime: '',
        defaultSeatingCapacity: 0,
        defaultSeatingDishes:[],
        defaultSeatingPriceModelId: '',
    }); 
    const [defaultMenuItem,setDefaultMenuItem] = useState<IDefaultDishContent>({
        defaultDishId: "",
        defaultDishName: "",
        defaultDishDescription: "",
        defaultDishFoodCategories: [],
        defaultDishAllergens: []
    })
    const [seating, setSeating] = useState<ISeatingContent>({
        id: '',
        name:"",
        description:"",
        officeId: "",
        seatingName: "",
        seatingStart: "",
        seatingEnd: "",
        seatingCapacity: 0,
        seatingDishes: [],
        priceModelId: "",
        priceModelVersion: ""
    });

    const [dish, setDish] = useState<IDishContent>({
        id: "",
        name: "",
        description: "",
        officeId: "",
        dishTitle: "",
        dishDescription: "",
        foodCategories: [],
        allergens: [],
        co2Impact: DISH_CO2_IMPACT_DEFAULT
    });

    // Context
    const officeContext = useContext(OfficeContext);

    // Entities
    const [seatings,setSeatings] = useState<IVersionedObject<ISeatingContent>[]>([]);
    const [bookings,setBookings] = useState<IVersionedObject<IBookingContent>[]>([]);
    const [dishes,setDishes] = useState<IVersionedObject<IDishContent>[]>([]);
    const [priceModels,setPriceModels] = useState<IVersionedObject<IPriceModelContent>[]>([]);


    /* Update local date if global different than today */
    useEffect(() => {
        let dateParam = queryParams.get(DATE_QUERY_PARAM)
        if(dateParam !== null){
            setDate(new Date(dateParam))
        }
    },[])

    /* Update local date if global different than today */
    useEffect(() => {
        if(date){
            let dateParam = queryParams.get(DATE_QUERY_PARAM)
            if(dateParam && dateParam !== simpleDate(date)){
                history.push({
                    pathname: history.location.pathname,
                    search: DATE_QUERY_PARAM + "=" + simpleDate(date)
                })
            }            
        }
    },[date])

    /*Get required info */
    async function getDatabase(){
        if(officeContext?.office){
            planEatApi.getSeatings().then((response) => setSeatings(response.data.filter(seating => seating.content.officeId === officeContext?.office?.content.id))).catch((e) => console.log(e))
            planEatApi.getBookings().then((response) => {setBookings(response.data)}).catch((e) => {console.log(e)})
            planEatApi.getDishes().then((response) => {setDishes(response.data)}).catch((e) => {console.log(e)})
            planEatApi.getPriceModels().then((response) => {
                const priceModelFilter = response.data.filter((priceModel) => priceModel.content.officeId === officeContext?.office?.content.id)
                const priceModelsSorted = priceModelFilter.sort((a,b) => a.content.name.localeCompare(b.content.name))
                setPriceModels(priceModelsSorted)
            }).catch((e) => {console.log(e)})
        }
    }

    useEffect(() => {
        getDatabase();
    }, [weekDates, officeContext?.office]);

    useEffect(() => {
        if(officeContext?.office){
            getDistinctSeatingsOnDates();
            getMinDate();
            displayDefaultSeatings();
        }
    }, [seatings, bookings, dishes, priceModels]);
    
    useEffect(() => {
        displayWeekDays();
        displayDefaultMenuItem();
    }, [officeContext?.office])
    
    useEffect(() => {
        displayWeekSeatings()
    }, [weekSeatings])

    useEffect(() => {
        /** Reset object in case of modal is closed */
        if(defaultSeatingHiddden){
            setDefaultSeating(resetDefaultSeating())
        } 
        
        if(defaultMenuItemModalHidden){
            setDefaultMenuItem(resetDefaultMenuItem())
        } 
        
        if(hidden){
            setSeating(resetSeating())
        }
    },[defaultSeatingHiddden,defaultMenuItemModalHidden,hidden])

    useEffect(() => {
        isFromToDatesSet()
    },[dateFrom && dateTo])

    async function getMinDate(){
        var tmpMinDate = new Date(minDate)

        if(tmpMinDate.getDay()=== 6){
            tmpMinDate.setDate(tmpMinDate.getDate() + 2)
        } else if (tmpMinDate.getDay()=== 0){
            tmpMinDate.setDate(tmpMinDate.getDate() + 1)
        }
        setMinDate(tmpMinDate)
        setDateTo(tmpMinDate)
        setDateFrom(tmpMinDate)
    }

    async function getDistinctSeatingsOnDates() {
        var tmpWeekSeatings : IVersionedObject<ISeatingContent>[][] = []
        for (let i = 0; i < weekDates.length; i++) {
            if(officeContext?.office){
                await FrontendApi.getSeatingsOnDate(weekDates[i],officeContext?.office.content.id,seatings).then((response) => {
                    tmpWeekSeatings[i] = response;
                }).catch((e) => {
                    console.log(e)
                })
            }
        }
        setWeekSetatings(tmpWeekSeatings);
    }

    function postSeating(dishId?: string){
        seating.seatingCapacity =+ seating.seatingCapacity
        if(officeContext?.office?.content?.id){
            seating.officeId = officeContext?.office?.content?.id;
        }

        if(isSeatingVerified(seating)){
            if(dish.id === NEW_ITEM_ID){
                dish.id = ""
                dish.officeId = seating.officeId

                planEatApi.postDish(dish)
                .then(response => {
                    setDish(resetDish)
                    var tmpSeating: ISeatingContent = clone<ISeatingContent>(seating)
                    tmpSeating.seatingDishes = [
                        {
                            dishId: response.data.content.id,
                            menuQuantity: seating.seatingCapacity
                        }
                    ]
                    
                    planEatApi.postSeating(tmpSeating)
                    .then(() => {
                        successToast("Seating and dish was created",seating.id);
                        setHidden(true);
                        setSeating(resetSeating());
                        getDatabase();
                    })
                    .catch((e) => {
                        extractErrorMessage(e, "Failed creating seating")
                        getDatabase();
                    })
                })
                .catch(error => {
                    toast.error("Failed creating dish")
                })
            } else if (dishId) {
                var tmpSeating: ISeatingContent = clone<ISeatingContent>(seating)
                tmpSeating.seatingDishes = [
                    {
                        dishId: dishId,
                        menuQuantity: seating.seatingCapacity
                    }
                ]

                planEatApi.postSeating(tmpSeating)
                .then(() => {
                    successToast("Seating",seating.id);
                    setHidden(true);
                    setSeating(resetSeating());
                    getDatabase();
                })
                .catch((e) => {
                    extractErrorMessage(e, "Failed creating seating")
                    getDatabase();
                })
            }
        }
    }

    function postDefaultSeating(tmpDefaultSeating: IDefaultSeatingContent) {
        if(officeContext?.office){
            tmpDefaultSeating.defaultSeatingCapacity = parseInt(tmpDefaultSeating.defaultSeatingCapacity.toString())

            // Set id if non
            if(tmpDefaultSeating.defaultSeatingId=== ''){
                tmpDefaultSeating.defaultSeatingId = uuidv4()
                officeContext?.office.content.defaultSeatings.push(tmpDefaultSeating)
            } else{
                officeContext?.office.content.defaultSeatings.forEach((defaultSeating,index) => {
                    if(tmpDefaultSeating.defaultSeatingId=== defaultSeating.defaultSeatingId){
                        officeContext.office?.content.defaultSeatings.splice(index,1)
                        officeContext.office?.content.defaultSeatings.push(tmpDefaultSeating)
                    }
                })
            }
            planEatApi.postOffice(officeContext?.office.content)
            .then((response) => {
                officeContext?.setOffice(response.data)
                successToast("Office",officeContext?.office?.content.id)
                setDefaultSeatingHidden(true)

                // Reset seating
                var tmpDefaultSeating = resetDefaultSeating()
                setDefaultSeating(tmpDefaultSeating)
                getDatabase();
            })
            .catch(() => {
                errorToast("Office",officeContext?.office?.content.id)
                getDatabase();
            })
        }
    }

    function postDefaultMenuItem() {
        if(officeContext?.office){
            if(officeContext.office.content.defaultDishesContent){
                if(defaultMenuItem.defaultDishId !== ""){
                    officeContext.office.content.defaultDishesContent.forEach((defaultDishContent,index) => {
                        if(defaultDishContent.defaultDishId=== defaultMenuItem.defaultDishId){
                            officeContext.office?.content.defaultDishesContent.splice(index,1)
                            officeContext.office?.content.defaultDishesContent.push(defaultMenuItem)
                        }
                    })
                } else {
                    defaultMenuItem.defaultDishId = uuidv4()
                    officeContext.office.content.defaultDishesContent.push(defaultMenuItem)
                }
            } else {
                var tmpDefaultDishContent: IDefaultDishContent = clone<IDefaultDishContent>(defaultMenuItem)
                tmpDefaultDishContent.defaultDishId = uuidv4()
                officeContext.office.content.defaultDishesContent = [tmpDefaultDishContent]
            }
            
            planEatApi.postOffice(officeContext?.office.content)
            .then(() => {
                setDefaultMenuItemModalHidden(true);
                displayDefaultMenuItem();
                successToast("Default Menu Item",officeContext?.office?.content.id);
                getDatabase();
            })
            .catch(() => {
                errorToast("Default Menu Item",officeContext?.office?.content.id);
                getDatabase();
            })
        }
    }

    function deleteSeating(seatingId: string) {
        planEatApi.postDeleteForSeating(seatingId)
        .then(() => {
            successToast("Seating",seating.id,undefined,true)
            setSeatingDeletionModalHidden(true);
            setSeating(resetSeating())
            getDatabase();
        })
        .catch(() => {
            errorToast("Seating",seating.id,undefined,true);
            getDatabase();
        })
    }

    function deleteSeatingWithMsg(seatingId: string,body:string) {
        planEatApi.postDeleteForSeatingWithMsg(seatingId,body)
        .then(() => {
            successToast("Seating",seating.id,undefined,true)
            setSeatingDeletionModalHidden(true);
            setSeating(resetSeating());
            getDatabase();
        })
        .catch(() => {
            errorToast("Seating",seating.id,undefined,true);
            getDatabase();
        })
    }

    function deleteDefaultSeating(tmpDefaultSeating: IDefaultSeatingContent) {
        if(officeContext?.office){
            officeContext?.office.content.defaultSeatings.forEach((defaultSeating,index) => {
                if(tmpDefaultSeating.defaultSeatingId=== defaultSeating.defaultSeatingId){
                    officeContext.office?.content.defaultSeatings.splice(index,1)
                }
            })

            planEatApi.postOffice(officeContext?.office.content)
            .then((response) => {
                officeContext?.setOffice(response.data)
                setDefaultSeatingHidden(true)
                successToast("Default Seating",officeContext?.office?.content.id,undefined,true)
                getDatabase();
            })
            .catch((e) => {
                errorToast("Default Seating",officeContext?.office?.content.id,undefined,true);
                getDatabase();
            }) 
        }
    }

    function deleteDefaultDishContent(tmpDefaultDishContent: IDefaultDishContent) {
        if(officeContext?.office){
            officeContext?.office.content.defaultDishesContent.forEach((defaultDishContent,index) => {
                if(defaultDishContent.defaultDishId=== tmpDefaultDishContent.defaultDishId){
                    officeContext.office?.content.defaultDishesContent.splice(index,1)
                }
            })
            
            planEatApi.postOffice(officeContext?.office.content)
            .then((response) => {
                officeContext?.setOffice(response.data);
                setDefaultSeatingHidden(true);
                successToast("Default Dish",officeContext?.office?.content.id,undefined,true);
                getDatabase();
            })
            .catch((e) => {
                errorToast("Default Dish",officeContext?.office?.content.id,undefined,true);
                getDatabase();
            }) 
        }
    }

    function isFromToDatesSet(){
        if(dateFrom && dateTo){
            var tmpAvailableDates : Date[] = []
            var tmpDate = new Date(dateFrom);
            var tmpDateTo = new Date(dateTo)
            tmpDateTo.setDate(dateTo.getDate() + 1)
            while(!datesAreOnSameDay(tmpDate,tmpDateTo)){
                tmpAvailableDates.push(new Date(tmpDate))
                tmpDate.setDate(tmpDate.getDate() + 1)
            }
            setAvailableDates(tmpAvailableDates)
        }
    }

    function generateSeatings(selectedDates:Date[],overrideAll:boolean){
        if(officeContext?.office){
            var dateStrings : string[] = [];

            selectedDates.forEach((selectedDate) => {
                dateStrings.push(to_YYYYMMDDHHMMSS(selectedDate))
            })
    
            planEatApi.postGenerateSeatings(dateStrings,overrideAll,officeContext?.office.content.id)
            .then(() => {
                setGenerateSeatingsModalHidden(true)
                toast.success("Seatings generated")
                getDatabase();
            })
            .catch(() => {
                toast.error("Seatings failed getting generated")
                getDatabase();
            })
        }
    }

    function updateWeekDay (selectedWeekDay: String) {
        if(officeContext?.office){
            var tmpWeekDays : any[] = []
            officeContext?.office.content.defaultAvailability.forEach((weekDay) =>{
                if(weekDay.weekDay=== selectedWeekDay){
                   weekDay.available = !weekDay.available;
                }
                tmpWeekDays.push(weekDay)
            })
            // Clone and update field
            var tmpOffice: IOfficeContent = clone<IOfficeContent>(officeContext.office.content)
            tmpOffice.defaultAvailability = tmpWeekDays

            planEatApi.postOffice(tmpOffice)
            .then((response) => {
                officeContext?.setOffice(response.data)
            })
            .catch((e) => {
                console.log(e);
            })
        } 
    }

    function displayWeekSeatings() {
        var tmpWeekSeatingsView : any[][] = []

        weekSeatings.forEach((weekSeating,i) =>{
            tmpWeekSeatingsView[i] = []
            weekSeating.forEach((seating,j) => {
                tmpWeekSeatingsView[i].push(
                    <div className={classes.dragAndDropDishContainer} key={seating.content.id}> 
                        <div className={classes.seatingInfoContainer}>
                            <div className={classes.dishNumberContainer}>
                                {j+1}
                            </div>
                            <div className={classes.seatingInfoContent}>
                                <b style={{minWidth:'100%'}}>{seating.content.seatingName}</b>
                                <div className={classes.seatingInfoIconContainer}>
                                    <MdAccessTime className={classes.seatingInfoIcon}/>
                                    <div>
                                        {prettyDate(seating.content.seatingStart,true,false)}
                                    </div>
                                    <MdPeopleAlt className={classes.seatingInfoIcon}/>
                                    <div>
                                        {seating.content.seatingCapacity}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={classes.flexRowCenter}>
                            <IconButton className={classes.editIconContainer} onClick={() => {setSeating(seating.content);setWeekDayIndex(i);setHidden(false)}}>
                                <MdModeEditOutline className={classes.editIconContent}/>
                            </IconButton>
                            <IconButton className={classes.editIconContainer}  onClick={() => {setSeatingDeletionModalHidden(false);setSeating(seating.content)}}>
                                <MdClose className={classes.editIconContent}/>
                            </IconButton>
                        </div>
                    </div>
                )
            })
            tmpWeekSeatingsView[i].push(
                <div className={classes.addMenuItemContainer}  onClick={() => {setHidden(false);setWeekDayIndex(i)}}>
                    <MdAddCircleOutline className={classes.addMenuIconStyle} />
                    <div className={classes.addMenuItemText}>
                        Add Seating
                    </div>
                </div>
            )
        })
        setWeekSeatingsView(tmpWeekSeatingsView)
    }

    function displayWeekDays() {
        if(officeContext?.office){
            if(officeContext?.office.content.defaultAvailability.length=== 7){
                var tmpWeekDayView : any[] = []
                
                officeContext?.office.content.defaultAvailability.forEach((weekDay) => {
                    tmpWeekDayView.push(
                        <div onClick={() => {updateWeekDay(weekDay.weekDay)}} className={classes.weekDayContainer} key={weekDay.weekDay}>
                            <div style={weekDay.available ? {fontWeight:700} : {fontWeight:400}}>
                                {weekDay.weekDay}
                            </div>
                            <CustomCheckBox selected={weekDay.available}/>
                        </div>
                    )
                })
                setWeekDaysView(tmpWeekDayView)
            } else{
                // Set default defaultAvailability as weekdays constant
                var tmpOffice: IOfficeContent = clone<IOfficeContent>(officeContext.office.content)
                tmpOffice.defaultAvailability = weekDays

                planEatApi.postOffice(tmpOffice)
                .then((response) => {
                    officeContext?.setOffice(response.data)
                })
                .catch((e) => {
                    console.log(e)
                })
            }
        } 
    }

    function displayDefaultSeatings() {
        var tmpDefaultSeatings : any[] = []

        if(officeContext?.office){
            const defaultSeatingsSorted = officeContext?.office?.content.defaultSeatings.sort((a, b) => a.defaultSeatingName.localeCompare(b.defaultSeatingName))
            defaultSeatingsSorted.forEach((tmpDefaultSeating,i) => {
                tmpDefaultSeatings.push(
                    <div className={classes.defaultSeatingOptionsContent} key={tmpDefaultSeating.defaultSeatingId}>
                        <div className={classes.defaultSeatingNumberContainer}>
                            <div className={classes.defaultSeatingNumberContent}>
                                {i+1}
                            </div>
                            {tmpDefaultSeating.defaultSeatingName}
                        </div>
                        <div>
                            {tmpDefaultSeating.defaultSeatingStartTime} - <br/> {tmpDefaultSeating.defaultSeatingEndTime}
                        </div>
                        <div>
                            {getPriceModels(tmpDefaultSeating.defaultSeatingPriceModelId)}
                        </div>
                        <div>
                            {getDishNamesFromDishId(tmpDefaultSeating.defaultSeatingDishes).toString()}
                        </div>
                        <div className={classes.flexRowSpaceBetween}>
                            <div>
                                {tmpDefaultSeating.defaultSeatingCapacity}
                            </div>
                            <div className={classes.flexRowCenter}>
                                <IconButton  onClick={() => {setDefaultSeating(tmpDefaultSeating);setDefaultSeatingHidden(false)}}>
                                    <MdModeEditOutline/>
                                </IconButton>
                                <IconButton  onClick={() => {deleteDefaultSeating(tmpDefaultSeating)}}>
                                    <MdClose/>
                                </IconButton>
                            </div>
                        </div>
                    </div>
                )
            })
        }
        setDefaultSeatingsView(tmpDefaultSeatings)
    }

    function getDishNamesFromDishId(dishIds : string[]) {
        var tmpDishNames : string[] = []

        if(dishIds){
            dishIds.forEach((dishId) => {
                if(officeContext?.office){
                    officeContext?.office.content.defaultDishesContent.forEach((defaultDishContent) => {
                        if(defaultDishContent.defaultDishId=== dishId){
                            tmpDishNames.push(defaultDishContent.defaultDishName)
                        }
                    })
                }
            })
        }
        return tmpDishNames
    }

    function displayDefaultMenuItem() {
        var tmpDefaultMenuItemsView : any[] = []
        if(officeContext?.office){
            if(officeContext?.office?.content.defaultDishesContent){
                const defaultDishSorted = officeContext?.office?.content.defaultDishesContent.sort((a, b) => a.defaultDishName.localeCompare(b.defaultDishName))
                defaultDishSorted.forEach((defaultMenuItem,i) => {
                    tmpDefaultMenuItemsView.push(
                        <div className={classes.defaultMenuItemRowContent} key={defaultMenuItem.defaultDishId}>
                            <div className={classes.defaultSeatingNumberContainer}>
                                <div className={classes.defaultSeatingNumberContent}>
                                    {i+1}
                                </div>
                                {defaultMenuItem.defaultDishName !== "" ? defaultMenuItem.defaultDishName : "No dish description specified"}
                            </div>
                            <div>
                                {defaultMenuItem.defaultDishDescription}
                            </div>
                            <div>
                                {defaultMenuItem.defaultDishFoodCategories.toString()}
                            </div>
                            <div className={classes.flexRowSpaceBetween}>
                            <div>
                                {defaultMenuItem.defaultDishAllergens.toString()}
                            </div>
                                <div className={classes.flexRowCenter}>
                                    <IconButton  onClick={() => {setDefaultMenuItem(defaultMenuItem);setDefaultMenuItemModalHidden(false)}}>
                                        <MdModeEditOutline/>
                                    </IconButton>
                                    <IconButton  onClick={() => {{deleteDefaultDishContent(defaultMenuItem);setDefaultMenuItemModalHidden(true)}}}>
                                        <MdClose/>
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                    )
                })   
            } 
        }
        setDefaultMenuItemsView(tmpDefaultMenuItemsView)
    }

    function getPriceModels(priceModelId: string): string {
        var priceModelName = ""
        priceModels.forEach(priceModel => {
            if(priceModel.content.id === priceModelId){
                priceModelName = priceModel.content.name;
            }
        }) 
        return priceModelName
    }

    return (
        <div>
            <div>
                <WeekPicker date={date} setDate={setDate} setWeekDates={setWeekDates} canCalendarPick={true}/>
            </div>
            <div>
                {weekDates.length > 0 ?
                    <div className={classes.dragAndDropRow}>  
                        <div className={classes.dragAndDropDayContainer}>
                            <div className={classes.dateTitle}>
                                {prettyDate(weekDates[0],false,true)}
                            </div>   
                            <div>
                                
                                {weekSeatingsView[0]}
                            </div>
                        </div >
                        <div className={classes.dragAndDropDayContainer}>
                            <div className={classes.dateTitle}>
                                {prettyDate(weekDates[1],false,true)}
                            </div>
                            <div>
                                {weekSeatingsView[1]}
                            </div>
                        </div>
                        <div className={classes.dragAndDropDayContainer}>
                            <div className={classes.dateTitle}>
                                {prettyDate(weekDates[2],false,true)}
                            </div>
                            <div>
                                {weekSeatingsView[2]}
                            </div>
                        </div>
                        <div className={classes.dragAndDropDayContainer}>
                            <div className={classes.dateTitle}>
                                {prettyDate(weekDates[3],false,true)}
                            </div>
                            <div>
                                {weekSeatingsView[3]}
                            </div>
                        </div>
                        <div className={classes.dragAndDropDayContainer}>
                            <div className={classes.dateTitle}>
                                {prettyDate(weekDates[4],false,true)}
                            </div>
                            <div>
                                {weekSeatingsView[4]}
                            </div>
                        </div>
                    </div>
                :
                    <div/>
                }
            </div>
            <div>
                <div className={classes.defaultSeatingContainer}>
                    <div className={classes.sectionTitle}>
                        Default settings
                    </div>
                    <div className={classes.sectionSubTitle}>
                        Set up your default seating options, times and availability
                    </div>
                </div>
                <div className={classes.defaultSeatingContent}>
                    <div className={classes.highlightedAdminContainer}>
                        <div>
                            <div className={classes.sectionTitle}>
                                Default seating options and times
                            </div>
                            <div className={classes.sectionSubTitle}>
                                These seating options will be applied by default to all available days.
                                You can override individual days using the calendar above.
                            </div>
                        </div>
                        <div className={classes.defaultSeatingOptionsContainer}>
                            <div className={classes.defaultSeatingOptionsHeaders}>
                                <div>
                                    Eating options
                                </div>
                                <div>
                                    Time
                                </div>
                                <div>
                                    Price model
                                </div>
                                <div>
                                    Default Dishes
                                </div>
                                <div>
                                    Capacity
                                </div>
                            </div>
                            <div>
                                {defaultSeatingsView}
                            </div>
                            <div className={classes.applySeatingContainer}>
                                <div className={classes.addMenuItemContainer} onClick={() => {setDefaultSeatingHidden(false)}}>
                                    <MdAddCircleOutline className={classes.addMenuIconStyle} />
                                    <div className={classes.addMenuItemText}>
                                        Add Default Seating
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={classes.highlightedAdminContainer}>
                            <div>
                                <div className={classes.sectionTitle}>
                                    Default availability
                                </div>
                                <div className={classes.sectionSubTitle}>
                                    Select the days of the week to apply the default
                                </div>
                            </div>
                            <div>
                                {weekDaysView}
                            </div>
                        </div>
                        <Button
                            variant="contained"
                            className={classes.generateSeatingsButton}
                            onClick={() => {setGenerateSeatingsModalHidden(false)}}
                        >
                            Generate Seatings
                        </Button>
                    </div>
                </div>
                <div className={classes.defaultMenuItemsContainer}>
                    <div>
                        <div className={classes.sectionTitle}>
                            Default menu items
                        </div>
                        <div className={classes.sectionSubTitle}>
                            Create list of default menu items
                        </div>
                    </div>
                    <div className={classes.defaultSeatingOptionsContainer}>
                        <div className={classes.defaultMenuItemRowHeaders}>
                            <div>
                                Dish Title
                            </div>
                            <div>
                                Dish Description
                            </div>
                            <div>
                                Food Category
                            </div>
                            <div>
                                Allergens
                            </div>
                        </div>
                        <div>
                            {defaultMenuItemsView}
                        </div>
                        <div className={classes.applySeatingContainer}>
                            <div className={classes.addMenuItemContainer} onClick={() => {setDefaultMenuItemModalHidden(false)}}>
                                <MdAddCircleOutline className={classes.addMenuIconStyle} />
                                <div className={classes.addMenuItemText}>
                                    Add default dish
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                { officeContext?.office && weekDates[weekDayIndex] && 
                    <SeatingCreationModal 
                        hidden={hidden} 
                        setHidden={setHidden} 
                        seating={seating} 
                        setSeating={setSeating} 
                        dish={dish}
                        setDish={setDish}
                        date={weekDates[weekDayIndex]} 
                        postSeating={postSeating} 
                        priceModels={priceModels} 
                        seatings={seatings}
                        dishes={dishes}  /> 
                }
                {officeContext?.office ?
                    <DefaultSeatingModal office={officeContext?.office.content} defaultSeatingHidden={defaultSeatingHiddden} setDefaultSeatingHidden={setDefaultSeatingHidden} defaultSeating={defaultSeating ? defaultSeating : undefined} setDefaultSeating={setDefaultSeating} postDefaultSeating={postDefaultSeating}></DefaultSeatingModal>
                    :
                    <div></div>
                }
                {officeContext?.office ?
                    <GenerateModal office={officeContext?.office.content} minDate={minDate} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} selectedDates={selectedDates} setSelectedDates={setSelectedDates} generateSeatingsModalHidden={generateSeatingsModalHidden} setGenerateSeatingsModalHidden={setGenerateSeatingsModalHidden} generateSeatings={generateSeatings}></GenerateModal>
                    :
                    <div></div>
                }
                <SeatingDeletionModal seatingDeletionModalHidden={seatingDeletionModalHidden} setSeatingDeletionModalHidden={setSeatingDeletionModalHidden} seating={seating} bookings={bookings} deleteSeating={deleteSeating} deleteSeatingWithMsg={deleteSeatingWithMsg}/>
                <DefaultMenuItemModal defaultMenuItemModalHidden={defaultMenuItemModalHidden} setDefaultMenuItemModalHidden={setDefaultMenuItemModalHidden} defaultMenuItem={defaultMenuItem} setDefaultMenuItem={setDefaultMenuItem} postDefaultMenuItem={postDefaultMenuItem}></DefaultMenuItemModal>
            </div>
        </div>
    );
}